import { HeaderConfig } from '../../_models/header-config.model';

/**
 * Class to store topnav layout config data
 */
export class TopnavLayoutConfig {
  /** A header config object */
  public header: HeaderConfig = new HeaderConfig();
}
